module.exports = __webpack_public_path__ + "static/media/Sharp-Technology-IGZO-Touch-performance-4.cceadd74.jpg";